import { render } from "./TermAndCondition.vue?vue&type=template&id=2a0e2b38&ts=true"
import script from "./TermAndCondition.vue?vue&type=script&lang=ts"
export * from "./TermAndCondition.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__